import { SUPER_ADMIN_ONLY } from "@excel-center/shared";

export const SUPER_ADMIN_ROLES = SUPER_ADMIN_ONLY;

export const POWERBI_URL_HOST_MATCH = "app.powerbi.com";
